import React, { Component } from 'react';
import { Table, Row, Button, message, Select } from 'antd';
import moment from 'moment';
import { inject, observer } from "mobx-react";
import { columns, columnsColumn, listName } from './data';
import TableText from "../../table/TableText";
import FileSaver from "file-saver";

const totalIndex = [];
const Option = Select.Option;
@inject('store')
@observer
class index extends Component {
    constructor(props) {
        super(props);
        const month = moment().format('M');
        this.state = {
            date: month < 3 ? moment().format('YYYY') : moment().add(1, 'y').format('YYYY'),
            loadingSave: false,
            print: false,
            data: [],
            loading: true,
            columnData: [],
            dateData: [],
        }
    }

    componentDidMount() {
        let date = Number(this.state.date || "0");
        let dateData = [];
        let len = date - 2018 + 3;
        for (let i = 0; i < len; i++) {
            dateData.push((2018 + i).toString())
        }
        this.setState({ dateData });
        this.getDateData(this.state.date);
    }


    onChange = (name, value, i) => {

    }

    getDateData = (date) => {
        fetch(`/bp/headquarters/8?year=${moment(date).format('YYYY')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            const data = x.data || [];
            this.setState({ data, loading: false });
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let data = this.state.data.map((x, i) => ({ ...x, year, }));

        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/bpAdd_8_0_new', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getDateData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    downloadExcel = (id) => {
        const tableName = `Budget Summary`
        const innerHtml = `
          <caption>${tableName}</caption>
          ${document.getElementById(id).innerHTML.replace(/<table class="">/g, '<table border="1">')}
        `;

        var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
        var blob = new Blob([html], { type: "application/vnd.ms-excel" });
        FileSaver.saveAs(blob, `${(tableName) + (this.state.date)}.xls`);
        this.setState({ print: false });
    }

    render() {
        const { print, data, date, loading, columnData } = this.state;
        const width = document.body.offsetWidth - 4800 > 500 ? document.body.offsetWidth - 4800 : 500;

        const columnsData = columns(date).map(item => {
            if (item.children) {
                return {
                    title: item.name,
                    children: item.children.map(v => {
                        return {
                            title: v.name,
                            dataIndex: v.key,
                            key: v.key,
                            align: "center",
                            width: 150,
                            render: (text = 0, record, index) => {
                                const title = [item.name, v.name];
                                const props = {
                                    text: text || 0, index, type: v.type, name: v.key, onChange: this.onChange, totalIndex,
                                    compared: {
                                        title,
                                        record,
                                        sqlName: "b8_0new_budget"
                                    }
                                };

                                return (
                                    <TableText data={props} />
                                )
                            }
                        }
                    })
                }
            }

            return {
                title: item.name,
                dataIndex: item.key,
                key: item.key,
                align: "center",
                width,
                fixed: print ? false : "left",
                render: (text = "", record, index) => {
                    const title = [item.name, item.name, record.name];
                    const props = {
                        text, index, type: item.type, name: item.key, onChange: this.onChange, totalIndex,
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }
        })

        return (
            <div>
                <div className="table7_1_1 tableHeight">
                    <Row className="title" style={{ width: print ? 5350 : 'auto' }}>
                        <Row>Budget Summary</Row>
                        <Row className="table-month">
                            <Select
                                placeholder="请选择年份"
                                style={{ width: 120, marginTop: 20 }}
                                value={this.state.date}
                                onChange={(str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getDateData(str)
                                }}
                            >
                                {this.state.dateData.map((x, i) => {
                                    return (
                                        <Option value={x} key={x}>{x}年</Option>
                                    )
                                })}
                            </Select>
                        </Row>
                        <Table
                            columns={columnsData}
                            dataSource={data}
                            size="middle"
                            id="table4_1_5"
                            bordered
                            loading={loading}
                            pagination={false}
                            rowClassName="protruding"
                            className="content"
                            style={{ width: print ? 5300 : 'auto' }}
                            scroll={print ? {} : { x: 5300, y: 500 }}
                            rowKey={(record, index) => index}
                        />
                    </Row>

                    <Row className="table-footer-btn">
                        <Button
                            type="primary"
                            onClick={() => {
                                this.setState({ print: true }, () => {
                                    this.downloadExcel("table4_1_5");
                                });
                            }}
                            loading={this.state.print}
                        >导出Excel</Button>
                    </Row>
                </div>
            </div>
        );
    }
}

export default index;



// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/BPBudgetSummary/index.js